import { TravelDirection } from '@/shared/types/common.types'
import HttpService from '../HttpService'
import type { UserInfo, FormDataResponse } from './UserService.types'

export class UserService extends HttpService {
  getUserInfo(
    accessToken: string,
    csrfToken: string,
    sourceId: string,
    language: string
  ): Promise<UserInfo> {
    return this.get<UserInfo>('/user/getuserinfo', {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'X-Csrf-Token': csrfToken,
        'Source-Id': sourceId,
        Version: '1',
        Language: language,
      },
    })
  }

  async getFormData(
    direction: TravelDirection,
    isFullFields = false
  ): Promise<FormDataResponse | null> {
    const requiredFields = ['phone', 'email']

    const personalFields = [
      'first_name',
      'last_name',
      'nationalityCode',
      'nationalityName',
      'passport_number',
      'birth_date',
      'gender',
    ]

    if (isFullFields) {
      requiredFields.push(...personalFields)

      if (direction === TravelDirection.OUTBOUND) {
        requiredFields.push('qatar_id', 'civil_id_expiry_date')
      }
    }

    const queryString = requiredFields
      .map((field) => `fields[]=${encodeURIComponent(field)}`)
      .join('&')

    const formData = await this.get<FormDataResponse>(`/getformdata?${queryString}`)

    const hasAllFields = requiredFields.every((field) => {
      const value = formData[field as keyof FormDataResponse]
      return value !== null && value !== undefined
    })

    if (hasAllFields) return formData

    return null
  }
}
